import CONF from 'config/conf.singleton';
import { AUTH_API } from 'middleware/api';

import { GET_STYLIST_FAILURE, GET_STYLIST_REQUEST, GET_STYLIST_SUCCESS } from 'onboarding/stylists/actions';

const fetchStylist = ({ stylistId, salonId }) => ({
  [AUTH_API]: {
    api_root: CONF.apiRoot,
    authenticated: true,
    endpoint: `salon/${salonId}/stylist/${stylistId}/`,
    types: [GET_STYLIST_REQUEST, GET_STYLIST_SUCCESS, GET_STYLIST_FAILURE],
  },
});

// noinspection JSUnusedGlobalSymbols
export default fetchStylist;
